import React, { useState } from "react";
import "./LoginModal.css";
import DynamicForm from "./DynamicForm";
import { useRegisterQueryMutation } from "../services/userAuthApi";

function RegistrationModal() {
  const [userType, setUserType] = useState("petOwner");
  const [apiError, setApiError] = useState("");
  const [apiSuccess, setApiSuccess] = useState("");

  const [registerQuery] = useRegisterQueryMutation();

  const handleRegistrationSubmit = async (formData) => {
    setApiError("");
    setApiSuccess("");

    try {
      // Transform form data for API
      const apiPayload = {
        ...formData,
        user_type: userType === "petOwner" ? "pet_owner" : "service_provider",
      };

      const response = await registerQuery(apiPayload).unwrap();
      
      if (response.success) {
        setApiSuccess("Registration successful! Please login to continue.");
        // Reset form after successful registration
        setTimeout(() => {
          // Close modal or redirect to login
          window.location.reload();
        }, 2000);
      } else {
        setApiError(response.message || "Registration failed. Please try again.");
      }
    } catch (error) {
      console.error("Registration error:", error);
      setApiError(error?.data?.message || "Registration failed. Please try again.");
    }
  };

  const formType = userType === "petOwner" ? "registration_pet_owner" : "registration_provider";

  return (
    <div
      className="modal fade"
      id="RegistrationModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered login-modal">
        <div className="modal-content login-modal-content">

          <button
            type="button"
            className="btn-close custom-close"
            data-bs-dismiss="modal"
          ></button>

          <div className="row g-0 h-100">

            {/* LEFT */}
            <div className="col-md-5">
              <div className="login-left">
                <div className="login-left-content">
                  <h5>Welcome To</h5>
                  <h1>Everything Pawzible</h1>
                  <p>Care • Connect • Compassion</p>
                </div>

                <img
                  className="pet-img"
                  src={`${process.env.PUBLIC_URL}/assets/imgs/banner_1.png`}
                  alt="Banner"
                />
              </div>
            </div>

            {/* RIGHT */}
            <div className="col-md-7">
              <div className="login-right">

                <div className="login-heading">
                  <h2>Sign Up</h2>
                  <p>
                    Already have an account?
                    <a
                      href="/"
                      data-bs-toggle="modal"
                      data-bs-target="#loginModal"
                    >
                      {" "}Login
                    </a>
                  </p>
                </div>

                {/* USER TYPE SELECTION */}
                <div className="user-type-wrapper mb-4">
                  <label className="user-type-card">
                    <input
                      type="radio"
                      checked={userType === "petOwner"}
                      onChange={() => {
                        setUserType("petOwner");
                        setApiError("");
                        setApiSuccess("");
                      }}
                    />
                    <span>❤️ Animal Lover</span>
                  </label>

                  <label className="user-type-card">
                    <input
                      type="radio"
                      checked={userType === "provider"}
                      onChange={() => {
                        setUserType("provider");
                        setApiError("");
                        setApiSuccess("");
                      }}
                    />
                    <span>🏥 Service Provider</span>
                  </label>
                </div>

                {/* API Messages */}
                {apiError && (
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    {apiError}
                    <button type="button" className="btn-close" onClick={() => setApiError("")}></button>
                  </div>
                )}
                {apiSuccess && (
                  <div className="alert alert-success alert-dismissible fade show" role="alert">
                    {apiSuccess}
                    <button type="button" className="btn-close" onClick={() => setApiSuccess("")}></button>
                  </div>
                )}

                {/* DYNAMIC FORM */}
                <DynamicForm
                  key={formType}
                  formType={formType}
                  onSubmit={handleRegistrationSubmit}
                  submitButtonText="Create Account"
                  showStepper={true}
                />

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default RegistrationModal;
